import React, { useState } from 'react';
import { Form, Select } from 'antd';
import { useGetAddressHints } from 'api/addresses/use-get-address-hints.ts';
import type { AddressField } from 'types/address.ts';

interface ICargoFiltersAddressInputProps {
  name: string;
  field: AddressField;
  handleSuccess: () => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  countryIds?: number[];
}

export const CargoFiltersAddressInput: React.FC<ICargoFiltersAddressInputProps> = (props) => {
  const { name, disabled = false, className, countryIds, handleSuccess, field, placeholder } = props;
  const [search, setSearch] = useState('');

  const { data: hints } = useGetAddressHints({ search, group: field, countryIds, isEnabled: search.length >= 2 });

  const handleSearch = (value: string) => {
    setSearch(value);
  };
  return (
    <Form.Item name={name} className={className}>
      <Select
        placeholder={placeholder}
        mode='multiple'
        disabled={disabled}
        allowClear
        onSearch={handleSearch}
        onChange={handleSuccess}>
        {hints?.map((hint) => (
          <Select.Option key={hint.value} value={hint.value}>
            {hint.value}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
